import { optimizedImage } from "@/lib/img";
import defaultAvatar from "@/assets/default-avatar.webp";
import { cn } from "@/lib/utils";

type Props = {
  src?: string | null | undefined;
  name?: string;
  className?: string;
  /** Verilərsə şəklin sağ aşağı küncündə online/offline nöqtəsi göstərilir. */
  online?: boolean;
};

/** İstifadəçi şəkli — yüklənməyibsə Albazar.az loqosu göstərilir. */
export function UserAvatar({ src, name = "İstifadəçi", className, online }: Props) {
  const img = (
    <img
      src={src ? optimizedImage(src, 96, 60) : defaultAvatar}
      alt={`${name} profil şəkli`}
      loading="lazy"
      width={96}
      height={96}
      className={cn("size-10 shrink-0 rounded-full border border-border object-cover", className)}
    />
  );
  if (online === undefined) return img;
  return (
    <span className="relative inline-flex shrink-0">
      {img}
      <span
        aria-label={online ? "Onlayn" : "Oflayn"}
        className={cn(
          "absolute bottom-0.5 right-0.5 h-3 w-3 rounded-full border-2 border-white",
          online ? "bg-green-500" : "bg-gray-400",
        )}
      />
    </span>
  );
}
